import {
    getCloudProjectsList, getServicesCloudsqlLatencyInfo, getServicesErrorRatesInfo,
    getServicesLatencyInfo, getServicesRequestCountInfo, isLoadingCloudProjects,
    isLoadingServicesCloudsqlLatency, isLoadingServicesErrorRates, isLoadingServicesLatency, isLoadingServicesRequestCount,
} from 'core/selectors';
import { getCloudProjects, getServicesCloudsqlLatency, getServicesErrorRates, getServicesLatency, getServicesRequestCount } from 'core/slices/services';
import { connect } from 'react-redux';
import ServicesMain from '../../../components/services/ServicesMain';

export default connect(
    state => ({
        servicesErrorRates: getServicesErrorRatesInfo(state),
        isLoadingServicesErrorRates: isLoadingServicesErrorRates(state),
        servicesCloudsqlLatency: getServicesCloudsqlLatencyInfo(state),
        isLoadingServicesCloudsqlLatency: isLoadingServicesCloudsqlLatency(state),
        servicesLatency: getServicesLatencyInfo(state),
        isLoadingServicesLatency: isLoadingServicesLatency(state),
        cloudProjects: getCloudProjectsList(state),
        isLoadingCloudProjects: isLoadingCloudProjects(state),
        servicesRequestCount: getServicesRequestCountInfo(state),
        isLoadingServicesRequestCount: isLoadingServicesRequestCount(state),
    }),
    {
        getServicesErrorRates,
        getServicesCloudsqlLatency,
        getServicesLatency,
        getCloudProjects,
        getServicesRequestCount,
    },
)(ServicesMain);